import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";

const MainContainer = styled.div`
  width: 670px;
  border-radius: ${props => (props.maxHeight > 0 ? "5px" : "0")};
  box-shadow: ${props =>
    props.maxHeight > 0 ? "0 40px 40px 0 rgba(119, 121, 132, 0.1)" : "0"};
  background-color: ${props => (props.maxHeight > 0 ? "#ffffff" : "auto")};
  margin-bottom: 18px;

  @media (max-width: 766px) {
    width: 100%;
    margin: 0 auto 18px auto;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const ExpansionPanelSummary = styled.div`
  cursor: pointer;
  height: 96px;
  border-radius: 5px;
  background-color: ${props =>
    props.maxHeight > 0 ? "#ffffff" : "rgba(119, 121, 132, 0.05)"};
  font-size: 18px;
  font-weight: 500;
  color: #1f2021;
  @media (max-width: 645px) {
    font-size: 16px;
  }
`;

const ExpansionPanelDetails = styled.div`
  opacity: 1;
  overflow: hidden;
  transition: ${props => props.trans};
  max-height: ${({ maxHeight }) => maxHeight}px;
  border-top: ${({ maxHeight }) =>
    maxHeight === 0
      ? "0px solid rgba(119, 121, 132, 0.1)"
      : "1px solid rgba(119, 121, 132, 0.1)"};
  font-size: 16px;
  line-height: 1.88;
  color: #777984;

  @media (max-width: 645px) {
    font-size: 15px;
  }
`;

const Typography = styled.div`
  height: 100%;
  padding-right: 30px;
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  padding-left: 30px;

  @media (max-width: 450px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 350px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const IconSpan = styled.span`
  justify-self: flex-end;
`;

const DetailsDiv = styled.span`
  padding: 30px 30px 30px 30px;
  display: block;

  @media (max-width: 450px) {
    padding: 30px 25px 30px 25px;
  }
`;

const TextP = styled.div`
  margin-top: 22px;
`;

const AnswerLink = styled(Link)`
  color: #12b2ea;
`;

const ExpansionPanel = ({
  otherIsClicked,
  item,
  handleOtherClicked,
  header,
  currentHeader,
  oneIsOpenend,
  idOfOldItem,
  setIdOfOldItem
}) => {
  const [expanded, setExpanded] = useState(false);
  const [trans, setTrans] = useState("800ms ease-in-out");
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (otherIsClicked !== item.id || currentHeader !== header) {
      setExpanded(false);
    }
  }, [otherIsClicked, currentHeader]);

  useEffect(() => {
    if (!oneIsOpenend || otherIsClicked !== item.id) {
      setTrans("300ms ease-in-out");
      setMaxHeight(0);
    }

    if (
      oneIsOpenend &&
      otherIsClicked === item.id &&
      currentHeader === header
    ) {
      setTrans("800ms ease-in-out");
      if (
        !idOfOldItem ||
        idOfOldItem === otherIsClicked ||
        item.id < idOfOldItem ||
        currentHeader !== header
      ) {
        setMaxHeight(600);
        setIdOfOldItem(otherIsClicked);
      } else {
        setTimeout(() => {
          setMaxHeight(600);
          setIdOfOldItem(otherIsClicked);
        }, 300);
      }
    }
  }, [oneIsOpenend, otherIsClicked]);

  const handleChange = () => {
    setExpanded(!expanded);
    handleOtherClicked(item.id, header);
  };

  return (
    <MainContainer maxHeight={maxHeight}>
      <ExpansionPanelSummary onClick={handleChange} maxHeight={maxHeight}>
        <Typography>
          <span>{item.question}</span>
          <IconSpan>
            <FaChevronDown
              style={{
                color: "rgba(119, 121, 132, 0.5)",
                fontSize: "14px",
                transform: expanded ? "rotate(180deg)" : "inherit",
                transition: "500ms transform"
              }}
            />
          </IconSpan>
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails trans={trans} maxHeight={maxHeight}>
        <DetailsDiv>
          {item.answer}
          {item.link && (
            <>
              {" "}
              <AnswerLink to={item.link}>{item.linkText}</AnswerLink>{" "}
            </>
          )}
          {item.afterLinkText && <span>{item.afterLinkText}</span>}
          {item.secondParagraph && <TextP>{item.secondParagraph}</TextP>}
          {item.list && (
            <ul>
              {item.list.map((listItem, index) => (
                <li key={index}>{listItem}</li>
              ))}
            </ul>
          )}
        </DetailsDiv>
      </ExpansionPanelDetails>
    </MainContainer>
  );
};

export default ExpansionPanel;
